import React from 'react';
import Hero from './Hero';
import Stats from './Stats';
import Products from './Products';
import Features from './Features';
import About from './About';
import Contact from './Contact';

const Home = () => {
  return (
    <>
      <Hero />
      <Stats />
      <Products />
      <Features />
      <About />
      <Contact />
    </>
  );
};

export default Home;